/**
 * Mask region adapters between the region shape the drawing UI uses and the
 * `protos.vision.generations.v1.MaskRegion` gRPC shape. The UI's regions carry a `kind`
 * discriminator plus a parallel `points`/`strokes` field; the proto models the geometry as a
 * `oneof`, so the `kind` is the oneof case. Coordinates are normalized 0..1 on both sides.
 */

function pointToProto([x, y]) {
  return { x: x ?? 0, y: y ?? 0 };
}

function pointToLegacy(point) {
  return [point.x ?? 0, point.y ?? 0];
}

export function maskRegionToProto(region) {
  const geometry =
    region.kind === 'brush'
      ? {
          case: 'brush',
          value: {
            strokes: (region.strokes ?? []).map((stroke) => ({
              sizeFraction: stroke.size ?? 0,
              points: (stroke.points ?? []).map(pointToProto),
            })),
          },
        }
      : {
          case: 'lasso',
          value: { points: (region.points ?? []).map(pointToProto) },
        };

  return {
    regionId: region.id ?? '',
    name: region.name ?? '',
    color: region.color ?? '',
    prompt: region.prompt ?? '',
    referenceAssetId: region.ref_image_id ?? '',
    visible: region.visible !== false,
    geometry,
  };
}

export function maskRegionToLegacy(region) {
  const base = {
    id: region.regionId,
    name: region.name,
    color: region.color,
    prompt: region.prompt,
    ref_image_id: region.referenceAssetId || null,
    visible: region.visible,
  };

  if (region.geometry?.case === 'brush') {
    return {
      ...base,
      kind: 'brush',
      strokes: (region.geometry.value.strokes ?? []).map((stroke) => ({
        size: stroke.sizeFraction ?? 0,
        points: (stroke.points ?? []).map(pointToLegacy),
      })),
    };
  }

  return {
    ...base,
    kind: 'lasso',
    points: (region.geometry?.value?.points ?? []).map(pointToLegacy),
  };
}

export function regionsToProto(regions) {
  return (regions ?? []).map(maskRegionToProto);
}

export function regionsToLegacy(regions) {
  return (regions ?? []).map(maskRegionToLegacy);
}
